import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const assetsAnalyticsDataViewDetailsEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(
			/* webpackChunkName: "async-assets-analytics-data-view-details-entrypoint" */ './index.tsx'
		).then((module) => module.AssetsAnalyticsDataViewDetailsPage),
	),
	getPreloadProps: () => ({}),
});
